'use client'
import { LightButton } from "@/ui/Button"
import { mergeModalLayerClassNames, useModalLayer } from "@/ui/modalLayer"
import { ModalProps, Modal, ModalContent, ModalHeader, ModalBody, Image } from "@heroui/react"

export default ({
  classNames,
  isOpen,
  ...props
}: Omit<ModalProps, 'children'> & {
  onPressPaypal: () => void, onPressPayssion: () => void,
  isPaypalLoading?
  isPayssionLoading?
}) => {
  const layer = useModalLayer(isOpen)
  return (
    <Modal
      isOpen={isOpen}
      classNames={mergeModalLayerClassNames(classNames, layer)}
      {...props}
    >
      <ModalContent>
        {(onClose) => (
          <>
            <ModalHeader>Пожалуйста, выберите способ оплаты</ModalHeader>
            <ModalBody className="pb-4">
              <LightButton startContent={<Image src="/imgs/paypal.png" alt="Paypal" width={60} />}
                className="font-bold"
                isLoading={props.isPaypalLoading}

                onPress={props.onPressPaypal}>Paypal</LightButton>
              <LightButton startContent={<Image src="/imgs/sber-pay-onecolor-sign-logo.png" alt="SberPay" width={60} />}
                className="font-bold"
                isLoading={props.isPayssionLoading}
                onPress={props.onPressPayssion}>SberPay</LightButton>
            </ModalBody>
          </>
        )}
      </ModalContent>
    </Modal>
  )
}